import { getStack } from "../constants/Stacks";

const stack = getStack();
const imageCdnBase = String(stack?.imageCDN || "").replace(/\/+$/, "");

const isAbsoluteUrl = (value) => String(value || "").indexOf("http") === 0;

const normalizeBase = (base) => String(base || "").replace(/\/+$/, "");

const normalizeRelative = (value) => String(value || "").trim();

const joinImageUrl = (baseCdn, relativeOrAbsoluteUrl) => {
    const raw = normalizeRelative(relativeOrAbsoluteUrl);
    if (!raw) {
        return "";
    }

    if (isAbsoluteUrl(raw)) {
        return raw;
    }

    const base = normalizeBase(baseCdn);
    if (!base) {
        return raw;
    }

    if (raw.startsWith("/cdn/") && base.endsWith("/cdn")) {
        return `${base}${raw.slice(4)}`;
    }

    if (raw.startsWith("/")) {
        return `${base}${raw}`;
    }

    return `${base}/${raw.replace(/^\/+/, "")}`;
};

const appendImageTransformParams = (url, options = {}) => {
    if (!url || !options || isAbsoluteUrl(url) === false) {
        return url;
    }

    if (!imageCdnBase || !String(url).startsWith(imageCdnBase)) {
        return url;
    }

    const params = new URLSearchParams();
    const width = Number.parseInt(options.w ?? options.width, 10);
    const height = Number.parseInt(options.h ?? options.height, 10);
    const quality = Number.parseInt(options.q ?? options.quality, 10);
    const format = typeof options.format === "string" ? options.format.trim().toLowerCase() : "";
    const fit = typeof options.fit === "string" ? options.fit.trim().toLowerCase() : "";
    const dpr = Number(options.dpr);

    if (Number.isFinite(width) && width > 0) {
        params.set("w", String(width));
    }
    if (Number.isFinite(height) && height > 0) {
        params.set("h", String(height));
    }
    if (Number.isFinite(quality) && quality > 0) {
        params.set("q", String(quality));
    }
    if (fit) {
        params.set("fit", fit);
    }
    if (format) {
        params.set("format", format);
    }
    if (Number.isFinite(dpr) && dpr > 0) {
        params.set("dpr", String(dpr));
    }

    const query = params.toString();
    if (!query) {
        return url;
    }

    return `${url}${url.includes("?") ? "&" : "?"}${query}`;
};

export const getMarkeringUrl = (url) => {
    return joinImageUrl(stack.imageCDN, url);
}

export const getProductImageUrl = (url, options = null) => {
    const absoluteUrl = joinImageUrl(stack.imageCDN, url);
    return appendImageTransformParams(absoluteUrl, options || {});
}

export const getCoffeeImageUrl = (url) => {
    return joinImageUrl(stack.coffeeCDN, url);
}
